"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComponent = exports.isRichText = exports.isBlock = void 0;

var _SanityBlockContent = _interopRequireDefault(require("../Sanity/components/SanityBlockContent"));

var _Text = _interopRequireDefault(require("../Text/Text/Text"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isBlock = function isBlock(item) {
  return item.hasOwnProperty("_type") && (item._type === "block" || item._type === "image");
};

exports.isBlock = isBlock;

var isRichText = function isRichText(val) {
  return Array.isArray(val) && val.some(function (arr) {
    return typeof arr !== "string" && Array.isArray(arr) && arr.some(function (item) {
      return item._type;
    });
  });
};

exports.isRichText = isRichText;

var getComponent = function getComponent(val) {
  return Array.isArray(val) ? val.map(getComponent) : isBlock(val) ? _react["default"].createElement(_SanityBlockContent["default"], {
    key: val._key,
    blocks: val
  }) : _react["default"].createElement(_Text["default"], {
    key: val
  }, val);
};

exports.getComponent = getComponent;